<template>
  <div class="checked-des">
    <div class="role-checked">
      <svg-icon icon-class="checked" />
      <span class="des-color">代表含有当前资源全部权限</span>
    </div>
    <div class="role-checked">
      <svg-icon icon-class="check_indeterminate" />
      <span class="des-color">代表含有当前资源部分权限</span>
    </div>
    <div class="role-checked">
      <svg-icon icon-class="unchecked" />
      <span class="des-color">当复选框勾选无反应，请点击【问题反馈】录入问题信息进行反馈</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkedDes',
  data () {
    return {}
  }

}
</script>

<style lang="scss" scoped>
.checked-des{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom:18px;
  .role-checked{
    font-size: 20px;
    display: flex;
    align-items: center;
    margin-right:10px
  }
  .des-color{
    font-size:12px;
    color:#e83223
  }
}
</style>
